import React from 'react';
import { RECRUIT_WIPE_MS } from '../recruitModeTransition';
import type { WipeOrigin } from '../recruitModeTransition';

/**
 * 色浪本身。一層蓋住整頁的圓形遮罩,由開關的座標擴張出去。
 *
 * 顏色不由 JS 決定 —— 兩個去向各有一個 class,實際的顏色寫在 styles.scss 裡,
 * 用的是同一組 --cv2-accent-* token。把十六進位色碼搬進 JS,等於在第二個地方
 * 再定義一次主題,而這一整套 PR 的前提就是主題只有一個地方。
 *
 * aria-hidden 且 pointer-events: none:它是一層漆,不是一個東西。
 */
export type RecruitModeWipeProps = {
  /** null 時不渲染 —— 沒有在轉場就沒有這一層。 */
  origin: WipeOrigin | null;
  to: 'recruit' | 'business';
};

const RecruitModeWipe = ({ origin, to }: RecruitModeWipeProps) => {
  if (!origin) return null;
  return (
    <div
      className={`clientv2-recruit-wipe is-to-${to}`}
      data-testid="recruit-wipe"
      aria-hidden="true"
      style={
        {
          '--wipe-x': `${origin.x}px`,
          '--wipe-y': `${origin.y}px`,
          '--wipe-ms': `${RECRUIT_WIPE_MS}ms`
        } as React.CSSProperties
      }
    />
  );
};

export default RecruitModeWipe;
